<template lang='pug'>
  .horizontal-selector(:class="{'left-overflow': leftOverflow, 'right-overflow': rightOverflow, 'dragging': dragging}")
    touch.inner-wrap(ref="innerWrap" @left="swipeLeft" @right="swipeRight" @tstart="startDrag" @tmove="drag" @tend="endDrag" :style="{width: innerWidth + 'px', 'margin-left': adjustedMargin + 'px'}")
      slot
</template>

<script>
  import touch from './touch';

  export default {
    name: "HorizontalSelector",

    data() {
      return {
        isMounted: false,
        changeWatcher: null,
        outerWidth: 0,
        innerWidth: 0,
        numChildren: 0,
        childWidth: 0,
        dragging: false,
        dragX: 0
      }
    },

    props: {
      selectedIndex: {
        type: Number
      },
      dragMode: {
        type: Boolean,
        default: false
      },
      centerMode: {
        type: Boolean,
        default: false
      }
    },

    computed: {
      adjustedMargin() {
        var offset = 0;
        var maxOffset = this.innerWidth > this.outerWidth ? this.innerWidth - this.outerWidth + 1 : 0;

        if (!this.centerMode && this.isMounted && this.innerWidth && this.outerWidth && this.numChildren && this.selectedIndex > 1) {
          var children = this.$refs['innerWrap'].$el.children;

          if (this.innerWidth > this.outerWidth) {
            for (var x = 0; x < this.selectedIndex - 2; x++) {
              offset += $(children[x]).outerWidth();
            }

            offset = offset + ($(children[this.selectedIndex - 2]).outerWidth() / 1.5);
            offset = offset * -1;
          }
        } else if (this.centerMode && this.isMounted && this.innerWidth && this.outerWidth && this.numChildren) {
          var children = this.$refs['innerWrap'].$el.children;

          if (this.innerWidth > this.outerWidth) {
            for (var x = 0; x < this.selectedIndex; x++) {
              offset += $(children[x]).outerWidth();
            }

            offset += $(children[this.selectedIndex]).outerWidth() / 2;
            offset = offset * -1;
            offset = offset + (this.outerWidth / 2);
            if (this.dragMode && this.dragging) {
              offset += this.dragX;
            }
            return offset;
          }
        }

        if (this.dragMode && this.dragging) {
          offset += this.dragX;
        }

        if (offset > 0) {
          return 0;
        }

        if (-1 * offset > maxOffset) {
          return -1 * maxOffset;
        }

        return offset;   
      },

      leftOverflow() {
        return this.adjustedMargin < 0;
      },

      rightOverflow() {
        return this.innerWidth + this.adjustedMargin > this.outerWidth;
      }
    },

    methods: {
      swipeLeft(distance) {
        this.$emit('swipeLeft', this.distanceInChildren('left', distance));
      },

      swipeRight(distance) {
        this.$emit('swipeRight', this.distanceInChildren('right', distance));
      },

      distanceInChildren(direction, distance) {
        if (this.numChildren == 0 || (direction == 'right' && this.selectedIndex == 0) || (direction == 'left' && this.selectedIndex == this.numChildren - 1)) {
          return 0;
        }
        var children = this.$refs['innerWrap'].$el.children;
        var childrenScrolled = 0;
        var remainingDistance = distance - ($(children[this.selectedIndex]).outerWidth() / 2);
        if (remainingDistance < 0) {
          remainingDistance = 1;
        }
        var increment = direction == 'right' ? -1 : 1;
        var childIndex = this.selectedIndex + increment;

        while (remainingDistance > 0 && children[childIndex]) {
          var childWidth = $(children[childIndex]).outerWidth();
          if (remainingDistance < childWidth) {
            childrenScrolled += remainingDistance / childWidth;
            remainingDistance = 0;
          } else {
            childrenScrolled += 1;
            remainingDistance += -childWidth;
          }

          childIndex += increment;
        }

        return childrenScrolled;
      },

      startDrag() {
        this.dragging = true;
      },

      drag(x) {
        this.dragX = x;
      },

      endDrag() {
        this.dragX = 0;
        this.dragging = false;
      },

      getInnerWidth() {
        if (!this.isMounted) {
          return 0;
        }
        var innerWidth = 0;
        
        for (var x = 0; x < this.$refs['innerWrap'].$el.children.length; x++) {
          innerWidth += $(this.$refs['innerWrap'].$el.children[x]).outerWidth();
        }

        innerWidth = Math.ceil(innerWidth + 1);
                
        return innerWidth;
      }
    },

    mounted() {
      this.isMounted = true;
      this.changeWatcher = setInterval(() => {
        this.outerWidth = $(this.$el).outerWidth();
        this.innerWidth = this.getInnerWidth();
        this.numChildren = this.$refs.innerWrap.$el.children.length;
        this.childWidth = $(this.$refs.innerWrap.$el.children[0]).outerWidth();
      }, 300);
    },

    destroyed() {
      clearInterval(this.changeWatcher);
    }
  }
</script>

<style scoped lang="stylus">
  .horizontal-selector
    width 100%
    
    .inner-wrap
      white-space nowrap
      transition(margin 300ms ease-in-out)
      
    &.dragging
      .inner-wrap
        transition(margin 30ms linear)
      
</style>
